<template>
  <fb-form-properties-manager :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "HtmlV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textarea",
          properties: {
            label: "Html"
          },
          property: "value"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
